import { render, staticRenderFns } from "./category-filed-type.vue?vue&type=template&id=0e50ea56&scoped=true&"
import script from "./category-filed-type.vue?vue&type=script&lang=js&"
export * from "./category-filed-type.vue?vue&type=script&lang=js&"
import style0 from "./category-filed-type.vue?vue&type=style&index=0&id=0e50ea56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e50ea56",
  null
  
)

export default component.exports